import {
  useMatrix,
  useUpdateMatrixIntercompanyInvoice,
} from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { useDisclosure, useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import {
  Button,
  Col,
  Divider,
  Form,
  Radio,
  Row,
  Skeleton,
  Typography,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import SettingsFiscalList from './SettingsFiscalList';
import SettingsFiscalCreateCertificateModal from '@/components/Settings/Fiscal/SettingsFiscalCreateCertificateModal';

interface FormValues {
  generateInvoiceDifferentCompanies: 0 | 1;
}

interface CertificateFormValues {
  certificateEmail: string;
  certificatePassword: string;
  certificateFile: { file: File };
  id?: number;
}

const SettingsFiscalPage: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl();
  const [form] = useForm<FormValues>();
  const [formCertificate] = useForm<CertificateFormValues>();
  const { data: matrix, dataUpdatedAt, isLoading } = useMatrix();
  const { width } = useWindowSize();

  const [modalVisible, setModalVisible] = useDisclosure();

  const updateIntercompanyInvoice = useUpdateMatrixIntercompanyInvoice();

  useEffect(() => {
    if (matrix) {
      form.setFieldsValue({
        generateInvoiceDifferentCompanies: Number(
          matrix.matrixSettings.generateInvoiceDifferentCompanies,
        ) as 0 | 1,
      });
    }
  }, [dataUpdatedAt]);

  function handleSubmit(values: FormValues) {
    updateIntercompanyInvoice.mutateAsync({
      generateInvoiceDifferentCompanies:
        !!values.generateInvoiceDifferentCompanies,
    });
  }

  return (
    <div className="page">
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <Skeleton loading={isLoading}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row justify="space-between" style={{ margin: 12 }} align="middle">
            <Col>
              <Typography.Title level={width < 576 ? 5 : 4}>
                Configurações para módulos fiscais
              </Typography.Title>
            </Col>

            {!(width < 992) && (
              <Col>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={updateIntercompanyInvoice.isLoading}
                >
                  Salvar
                </Button>
              </Col>
            )}
          </Row>

          <Form.Item
            label="Permitir gerar nota fiscal para empresa diferente?"
            name="generateInvoiceDifferentCompanies"
          >
            <Radio.Group>
              <Radio value={1}>Sim</Radio>
              <Radio value={0}>Não</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Skeleton>

      {width < 992 && (
        <Button
          block
          type="primary"
          htmlType="submit"
          loading={updateIntercompanyInvoice.isLoading}
        >
          Salvar
        </Button>
      )}

      <Divider />

      <Form form={formCertificate} layout="vertical">
        <Row justify="space-between" style={{ margin: 12 }} align="middle">
          <Col>
            <Typography.Title level={width < 576 ? 5 : 4}>
              Certificado Digital
            </Typography.Title>
          </Col>

          {!(width < 992) && (
            <Col>
              <Button
                block
                type="primary"
                htmlType="submit"
                onClick={() => setModalVisible.toggle()}
              >
                Cadastrar certificado
              </Button>
            </Col>
          )}
        </Row>
      </Form>

      {width < 992 && (
        <Button
          block
          type="primary"
          htmlType="submit"
          onClick={() => setModalVisible.toggle()}
        >
          Cadastrar certificado
        </Button>
      )}

      <SettingsFiscalList />

      <SettingsFiscalCreateCertificateModal
        onCancel={setModalVisible.close}
        open={modalVisible}
      />
    </div>
  );
};

export default SettingsFiscalPage;
